import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  // Set item in local storage
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  // Get item from local storage
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  // Remove item from local storage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items in local storage
  clear(): void {
    localStorage.clear();
  }
}
